import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import personalRouterV1 from './personalRouterV1'
import rechargeLimitV1 from './rechargeLimitV1'
import FN from '@/common/fn'
Vue.use(Router)
let baseRouter = [
  {
    path: '/',
    redirect: '/v1/personal'
  }
]
let routes = new Set([...personalRouterV1, ...baseRouter, ...rechargeLimitV1])
const router = new Router({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  // if (to.meta.isLoding) {
  //   document.getElementById('loading-con').style.display = 'block'
  // }
  next()
  setTimeout(() => {
    store.commit('SET_HEADER_TEXT', to.meta.title)
    document.title = to.meta.title
  })
})
router.afterEach((to, from, next) => {
  document.getElementById('loading-con').style.display = 'none'
  window.scrollTo(0, 0)
  // ISO 返回
  if (FN.isIOS) {
    var message = ''
    if (to.name === 'Personal') {
      message = { 'method': 'goback', 'flag': true, 'title': to.meta.title }
    } else {
      message = { 'method': 'goback', 'flag': false, 'title': to.meta.title }
    }
    try {
      window.webkit.messageHandlers.GAMESDK.postMessage(message)
      window.goback = function (flag) {
        if (flag) {
          router.go('-1')
        }
      }
    } catch (error) {
      // console.log(error)
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js